import { render, staticRenderFns } from "./NewResource.vue?vue&type=template&id=865734ca&scoped=true"
import script from "./NewResource.vue?vue&type=script&lang=js"
export * from "./NewResource.vue?vue&type=script&lang=js"
import style0 from "./NewResource.vue?vue&type=style&index=0&id=865734ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865734ca",
  null
  
)

export default component.exports